<template>
  <div class="layout-flex">
    <div
      class="layout-flex-2 layout-flex-child"
      :style="{'justify-content':listObj.imgs.length?'space-between':'center'}"
    >
      <div class="item-roll">
        <div class="item-text-content">
          <div class="item-title">
            <div class="item-line">{{listObj.title}}</div>
          </div>
          <div class="item-title-sub">{{listObj.subtitle}}</div>
          <div class="item-title-sub">{{listObj.subtitleEn}}</div>
          <div class="item-roll-child" ref="roll" :style="{height: autoHeight}">
            <div class="item-text-content" :style="aa">
              <div class="item-dec" v-html="listObj.dec"></div>
              <div class="item-dec" v-html="listObj.decEn"></div>
            </div>
          </div>
        </div>
        <div class="item-btn">
          <img
            v-show="scrollHeight>rollclientWidth"
            src="../../assets/meb/imgs/xczj/iconM@2x.png"
            style="width:100%"
            @click="handleTop"
          />
          <img
            v-show="scrollHeight<=rollclientWidth"
            src="../../assets/meb/imgs/xczj/iconS@2x.png"
            style="width:100%"
            @click="handleBottom"
          />
          <!-- <el-button type="primary" icon="el-icon-top" circle @click="handleTop"></el-button>
          <el-button type="primary" icon="el-icon-bottom" circle @click="handleBottom"></el-button> -->
        </div>
      </div>
      <div v-if="listObj.imgs.length" class="item-img-content">
        <img class="item-img" v-for="(item,index) in listObj.imgs" :key="index" :src="item" />
      </div>
    </div>
    <div class="layout-flex-1">
      <contentVideo v-if="listObj.videourl" :url="listObj.videourl" :img="listObj.videoimg"></contentVideo>
      <contentImage v-if="listObj.imageurl" :url="listObj.imageurl"></contentImage>
    </div>
  </div>
</template>

<script>
import contentVideo from "./contentVideo.vue";
import contentImage from "./contentImage.vue";
export default {
  components: {
    contentVideo,
    contentImage
  },
  props: {
    list: {},
  },
  data() {
    return {
      listObj: this.list,
      toMove: 0,
      scrollHeight: 200,
      autoHeight: "150px",
      rollclientWidth: 173
    };
  },
  computed: {
    aa() {
      var toMove = this.toMove;
      return `transform: translate(0px, ${toMove}px)`;
    }
  },
  beforeMount() {
    let _w = document.documentElement.clientWidth || document.body.clientWidth;
    // 可见高度
    if (_w >= 1600) {
      this.autoHeight = 280 + "px";
    } else {
      this.autoHeight = 150 + "px";
    }
    // 可见高度+移动 == 触底高度
    this.rollclientWidth = Number.parseInt(this.autoHeight) + 23;
    
  },
  mounted() {
    console.log(this.listObj);
    let roll = this.$refs.roll;
    // 滚动高度
    this.scrollHeight = roll.scrollHeight;
  },
  methods: {
    //文字向上移动
    handleTop() {
      let roll = this.$refs.roll;
      console.log("滚动",roll.scrollHeight);
      // 触底
      if (roll.scrollHeight <= this.rollclientWidth) {
        return;
      }
      this.toMove = this.toMove - 100;
      this.$nextTick(() => {
        this.scrollHeight = roll.scrollHeight;
        console.log(roll.scrollHeight);
      });
    },
    //文字回到第一行
    handleBottom() {
      // if (this.toMove >= 0) {
      //   return;
      // }
      // this.toMove = this.toMove + 100;

      this.toMove = 0;
      this.$nextTick(() => {
        let roll = this.$refs.roll;
        this.scrollHeight = roll.scrollHeight;
        console.log(roll.scrollHeight);
      });
    }
  }
};
</script>

<style lang="less" scoped>
.layout-flex {
  width: 1200px;
  padding: 49px 60px 49px 68px;
  box-sizing: border-box;
  display: flex;
  margin-left: auto;
  margin-right: auto;
  .layout-flex-1 {
    width: 563px;
    height: 315px;
  }
  .layout-flex-2 {
    margin-right: 83px;
    width: 425px;
    height: 315px;
    overflow: hidden;
  }
}

.layout-flex-child {
  display: flex;
  flex-direction: column;
  justify-content: center;
  .item-line {
    float: left;
    border-bottom: 3px solid rgba(40, 132, 244, 0.2);
  }
  .item-iconTit {
    width: 16px;
    height: 22px;
    padding-right: 10px;
  }
  .item-title {
    height: 30px;
    line-height: 20px;
    font-size: 22px;
    font-weight: 400;
    color: #0077c8;
  }
  .item-title-sub {
    font-size: 16px;
    font-weight: 400;
    color: #999999;
    clear: both;
    margin-top: 10px;
  }
  .item-dec {
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 18px;
    margin-top: 23px;
  }
  .item-roll {
    height: 100%;
    position: relative;
  }

  .item-text-content {
    height: 100%;
  }

  .item-roll-child {
    height: 150px;
    overflow: hidden;
  }

  .item-btn {
    position: absolute;
    right: 0;
    bottom: 0;
  }
  .item-img-content {
    height: 143px;
  }
  .item-img {
    width: 203px;
    height: 143px;
    margin-left: 19px;
  }
  .item-img:first-child {
    margin-left: 0px;
  }
}

@media screen and (min-width: 1600px) {
  .layout-flex {
    width: 1600px;
    .layout-flex-1 {
      width: 760px;
      height: 430px;
    }
    .layout-flex-2 {
      margin-left: 83px;
      width: 600px;
      height: 430px;
    }
  }

  .layout-flex-child {
    .item-title {
      font-size: 24px;
      line-height: 30px;
    }
    .item-dec {
      font-size: 16px;
      line-height: 28px;
    }
    .item-img-content {
      height: 190px;
    }
    .item-img {
      width: 270px;
      height: 190px;
      margin-left: 29px;
    }
  }
}
</style>
